export default {
  badInput: 'Die Eingabe scheint ungültig zu sein',
  customError: 'Die Eingabe scheint ungültig zu sein',
  patternMismatch: 'Die Eingabe scheint ungültig zu sein',
  rangeOverflow: 'Die Eingabe muss kleiner oder gleich %s sein',
  rangeUnderflow: 'Die Eingabe muss größer oder gleich %s sein',
  stepMismatch: 'Die Eingabe scheint ungültig zu sein',
  tooLong: 'Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden',
  tooShort: 'Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden',
  typeMismatch: 'Die Eingabe scheint ungültig zu sein',
  valueMissing: 'Dies ist ein Pflichtfeld',
};
